export const PROJECT_ASSET_TEST_ACTIONS = {
    PROJECT_ASSET_TEST_PAGE_LOADED: 'PROJECT_ASSET_TEST_PAGE_LOADED',
    PROJECT_ASSET_TEST_PAGE_UNLOADED: 'PROJECT_ASSET_TEST_PAGE_UNLOADED',
  };
  